import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: frankgrinaert
 * id 43E8F715-D3DB-4CAA-9355-88E22C7E4D28
 * name archive-arrow-up
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-arrow-up.svg
 * tags
 */
export const ArchiveArrowUpIcon = createSvgIcon(<><path d="M4 21H20V8H4M14 15V18H10V15H7L12 10L17 15M3 3H21V7H3" /></>, 'ArchiveArrowUpIcon');
export default ArchiveArrowUpIcon